/** @format */

import request from 'src/utils/request'
// 获取公共函数列表
export const getPublicFunctionList = async params => {
  const result = await request('/oos/?Action=ListScript&Version=2025-01-01', {
    data: {
      Type: 'func',
      ...params
    },
    method: 'POST'
  })
  return result?.data?.Data || { Info: [], Total: 0 }
}

// 获取函数详情
export const getFunctionDetail = async (params?: {
  ID?: number | string // ID可以是数字（版本ID）或字符串（Sign）
  Sign?: string
  Latest?: boolean
}) => {
  const queryParams = new URLSearchParams()
  if (params?.ID) {
    queryParams.append('ID', params.ID.toString())
  }
  if (params?.Sign) {
    queryParams.append('Sign', params.Sign)
  }
  if (params?.Latest !== undefined) {
    queryParams.append('Latest', params.Latest.toString())
  }

  const url = `/oos/?Action=GetScript&Version=2025-01-01${
    queryParams.toString() ? '&' + queryParams.toString() : ''
  }`
  const result = await request(url, {
    method: 'GET'
  })
  return result?.data?.Data || null
}

// 获取函数版本列表
export const getFunctionVersions = async sign => {
  const result = await request('/oos/?Action=ListScript&Version=2025-01-01', {
    data: {
      Type: 'func',
      Sign: sign,
      Limit: 0,
      Offset: 0
    },
    method: 'POST'
  })
  return result?.data?.Data?.Info || []
}

// 删除函数（通过Sign）
export const deleteFunctionBySign = async sign => {
  const result = await request('/oos/?Action=DeleteScript&Version=2025-01-01', {
    data: {
      Sign: sign
    },
    method: 'POST'
  })
  // 接口返回格式: { "RequestID": "...", "Data": "c_save_req" }
  // 如果返回的 Data 是 Sign 值，说明删除成功
  if (result?.data?.Data === sign || result?.code === 'Success') {
    return {
      code: 'Success',
      message: '删除成功',
      data: result?.data
    }
  }
  return result
}

// 保存脚本（创建或更新）
export const saveScript = async params => {
  try {
    const result = await request('/oos/?Action=SaveScript&Version=2025-01-01', {
      data: params,
      method: 'POST'
    })
    return result?.data?.Data || null
  } catch (error: any) {
    // 抛出错误以便上层处理
    throw error
  }
}

// 获取函数影响范围
export const getFunctionReach = async sign => {
  const result = await request(`/oos/?Action=GetScriptFuncReach&Version=2025-01-01&Sign=${sign}`, {
    method: 'GET'
  })
  return result?.data?.Data || []
}

// 测试脚本
export const testScript = async params => {
  const result = await request('/oos/?Action=StartScriptTest&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Data || null
}

// 创建审批
export const createAudit = async params => {
  const result = await request('/oos/?Action=CreateAudit&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result
}

// 加密变量
export const createEncryption = async (val: string) => {
  const result = await request('/oos/?Action=CreateEncryption&Version=2025-01-01', {
    data: {
      Val: val
    },
    method: 'POST'
  })
  return result?.data?.Data?.Encryption || null
}

// 审批
export const applyAudit = async (params?) => {
  const result = await request('/oos/?Action=ApplyAudit&Version=2025-01-01', {
    data: params || {},
    method: 'POST'
  })
  return result
}
